import React, { useState, useEffect } from "react";
import i18n from "@dhis2/d2-i18n";
import classes from "../../App.module.css";
import { makeStyles } from "@material-ui/core/styles";
import { apiServices } from "../../services/apiServices";
import SearchBar from "../../component/searchbar/SearchBar";
import CaseList from "./NewThemeCaseList";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import Pagination from "@material-ui/lab/Pagination";
import Grid from "@material-ui/core/Grid";
import {
  Button,
  ButtonStrip,
  Divider,
  InputFieldFF,
  SingleSelectFieldFF,
  ReactFinalForm,
  hasValue,
  InputField,
  CircularLoader,
  CenteredContent,
} from "@dhis2/ui";
import { withTranslation, Trans, useTranslation } from "react-i18next";
import swal from "sweetalert";
import OfflineDb from "../../db";
import { useGlobalSpinnerActionsContext } from "../../context/GlobalSpinnerContext";
//import {Configuration} from '../../assets/data/config'
import "../../assets/css/customstyles.css";
//import '../../assets/css/theme_grey.css'
import "../../assets/css/theme_blue.css";
// import '../../assets/css/theme_green.css'
// import '../../assets/css/theme_red.css'
import _ from "lodash";
import FooterMenu from "../../component/layout/FooterMenu";
import CardList from "../../component/contentList/CardList";
import AccordianList from "../../component/contentList/AccordianList";
import CaseListInTableView from "../cases/CaseListInTableView";
import moment from "moment";
import { useHistory } from "react-router";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

const { Form, Field } = ReactFinalForm;

function Followup() {
  const [sessionUserBoValue, setSessionUserBoValue] = React.useState(null);
  const [programData, setprogramData] = useState(null);
  const [customSearch, setCustomSearch] = useState([]);
  const [UICSearch, setUICSearch] = useState([]);
  const [input, setInput] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [searchAllResult, setSearchAllResult] = useState([]);
  const [value, setValue] = useState([]);
  const [firstNameId, setFirstNameId] = useState(null);
  const [famliyNameId, setfamilyNameId] = useState(null);
  const [givenName, setGivenName] = useState(null);
  const [customfieldobj, setcustomfieldobj] = useState(null);
  const history = useHistory();
  // const [loading,setGlobalSpinner] = useState(false)
  const { t } = useTranslation();
  const [viewType, setViweType] = useState("list");
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const listOfFields =
    programData != null
      ? programData.programs[0].programTrackedEntityAttributes
      : [];
  const fieldsToDisplay = listOfFields.filter(
    (obj) => obj.displayInList == true
  );

  //pagination code
  //const itemsPerPage = Configuration.pagination.itemsPerPage
  const [page, setPage] = useState(1);
  const [noOfPages, setNoOfPages] = useState(0);
  const [Configuration, setConfiguration] = useState(null);
  const [genderId, setgenderId] = useState(null);
  const [ageId, setageId] = useState(null);
  const [regdateId, setregdateId] = useState(null);
  const [uicId, setuicId] = useState(null);
  const [contactnumberId, setcontactnumberId] = useState(null);
  const [datatableList, setDatatableList] = useState([]);
  const headerName = [
    "Patient Name",
    "Family Name",
    "Gender",
    "Age",
    "Date of registration",
    "UIC",
    "phone number (permanent)",
    "instance",
  ];
  const [patientnameinput, setPatientNameInput] = useState("");
  const columnHeader = [
    {
      name: t("Patient Name"),
      selector: (row) => (row["patientName"] ? row["patientName"] : "-"),
    },
    {
      name: t("Famliy Name"),
      selector: (row) => (row["famliyName"] ? row["famliyName"] : "-"),
    },
    {
      name: t("Gender"),
      selector: (row) => (row["gender"] ? row["gender"] : "-"),
    },
    {
      name: t("Age"),
      selector: (row) => (row["age"] ? row["age"] : "-"),
    },
    {
      name: t("Date of registration"),
      selector: (row) =>
        row["regDate"] ? moment(row["regDate"]).format("YYYY-MM-DD") : "-",
    },
    {
      name: t("UIC"),
      selector: (row) => (row["uic"] ? row["uic"] : "-"),
    },
    {
      name: t("Contact number"),
      selector: (row) => (row["contactNumber"] ? row["contactNumber"] : "-"),
    },
    // {
    //   name: "Edit",
    //   selector: (row) => row.edit,
    // },
    {
      name: "Follow Up",
      selector: (row) => row.followup,
    },
  ];

  async function getMetaData() {
    let metadata = await OfflineDb.getDataFromPouchDB("metaData");
    console.log("metadata", metadata);
    setprogramData(metadata.data);

    let loginDetails = await OfflineDb.getDataFromPouchDB("loginDetails");
    setSessionUserBoValue(loginDetails.data);

    let configurations = await OfflineDb.getDataFromPouchDB("configurations");
    setConfiguration(configurations.data.configuration);
  }

  const normalizeDate = (dateString) => {
    const date = new Date(dateString); // Parse the date string
    date.setHours(0, 0, 0, 0); // Set time to 00:00:00
    return date;
  };
  let today = new Date()
    today.setHours(0, 0, 0, 0);

  function getCustomVariableIds() {
    let tempobj = {};
    programData.programs[0].programTrackedEntityAttributes.map((regField) => {
      let regFieldName = regField.trackedEntityAttribute.description
        ? regField.trackedEntityAttribute.description
        : regField.trackedEntityAttribute.displayName;
        console.log("regFieldName", regFieldName);

      if (regFieldName.trim().toLocaleLowerCase() == "patient name") {
        setFirstNameId(regField.trackedEntityAttribute.id);
        setGivenName(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["firstNameId"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName.trim().toLocaleLowerCase() == "family name") {
        setfamilyNameId(regField.trackedEntityAttribute.id);
        // setGivenName(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["famliyNameId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLocaleLowerCase() == "gender") {
        setgenderId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["genderId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLocaleLowerCase() == "age") {
        setageId(regField.trackedEntityAttribute.id);
        tempobj = { ...tempobj, ["ageId"]: regField.trackedEntityAttribute.id };
      }

      if (regFieldName.trim().toLocaleLowerCase() == "date of registration") {
        setregdateId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["regdateId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLocaleLowerCase() == "uic") {
        setuicId(regField.trackedEntityAttribute.id);
        tempobj = { ...tempobj, ["uicId"]: regField.trackedEntityAttribute.id };
      }

      if (
        regFieldName.trim().toLocaleLowerCase() == "phone number (permanent)"
      ) {
        setcontactnumberId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["contactnumberId"]: regField.trackedEntityAttribute.id,
        };
      }
    });

    setcustomfieldobj(tempobj);
  }

  useEffect(() => {
    getMetaData();
    OfflineDb.removeDataFromPouchDB("activeCaseDetails");
    OfflineDb.removeDataFromPouchDB("activeCaseFormData");
    OfflineDb.removeDataFromPouchDB("linkContactFlag");
    OfflineDb.setDataIntoPouchDB("transferFlag", { type: null });
  }, []);

  useEffect(() => {
    if (programData) getCustomVariableIds();
  }, [programData]);

  //once user bco is set call getContactList function
  useEffect(() => {
    if (sessionUserBoValue != null && Configuration != null) {
      getCasesList();
    }
  }, [sessionUserBoValue, Configuration]);
  useEffect(() => {
    if (searchResult && searchResult.length > 0 && Configuration != null) {
      setNoOfPages(
        Math.ceil(searchResult.length / Configuration.pagination.itemsPerPage)
      );
    }
  }, [searchResult, Configuration]);

  function getCasesList(param) {
    //localStorage.removeItem('trackedEntityInstance')
    setGlobalSpinner(true);
    let orgID = sessionUserBoValue.organisationUnits[0].id, //`UuYrI1twhmN`,
      programID = sessionUserBoValue.programs[0], //`nSy7PFqQykt`,
      searchQuery = ``;

    for (var i in param) {
      searchQuery += `&attribute=${i}:LIKE:${param[i]}`;
    }

    let subURL1 = "indicators/getFollowupList";
    let params = {
      puid: programID,
      orguid: orgID,
    };
    apiServices
      .postAPI(subURL1, params)
      .then((res) => {
        if (_.isEmpty(res.data.data)) {
          swal({
            title: t("Success"),
            text: t("No records found"),
            icon: "success",
            button: t("Close"),
          }).then((res) => {
            if (res) {
              //history.push('layout/home')
            }
          });
        } else {
          var resultObj = {
            Transfer: res.data.data,
          };
          console.log("searchresult", res.data.data);
          setSearchResult(res.data.data);
          setSearchAllResult(res.data.data);
          

          try {
            let filterData = [];
            res.data.data.map((ele, i) => {
              let obj = {
                patientName: ele[firstNameId],
                famliyName: ele["Family Name"],
                gender: ele[genderId],
                age: ele[ageId],
                contactNumber: ele[contactnumberId],
                uic: ele[uicId],
                regDate: ele[regdateId],
                edit: (
                  <EditIcon
                    className="edit-icon"
                    onClick={(e) => UpdateRecordClick(e, ele, "edit")}
                  //   onClick={(e) => {
                  //     const appointmentDate = normalizeDate(ele["appointmentdate"])

                  //     // Convert dates to YYYY-MM-DD format for comparison
                  //     const formatDate = (date) => {
                  //         const d = new Date(date);
                  //         return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
                  //     };

                  //     const formattedAppointmentDate = formatDate(appointmentDate);
                  //     const formattedToday = formatDate(today);

                  //     if (formattedAppointmentDate === formattedToday) {
                  //         UpdateRecordClick(e, ele, "edit");
                  //     } else {
                  //         swal({
                  //             // title: t("info"),
                  //             text: t("You can only edit the record on the day of appointment."),
                  //             icon: "info",
                  //             button: t("Close")
                  //         });
                  //     }
                  // }}
                  />
                ),
                followup: (
                  <ArrowForwardIcon
                  onClick={(e) => UpdateRecordClick(e, ele, "followup")}
                  //   onClick={(e) => {
                  //     const appointmentDate = normalizeDate(ele["appointmentdate"]);
                  //     const formatDate = (date) => {
                  //         const d = new Date(date);
                  //         return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
                  //     };

                  //     const formattedAppointmentDate = formatDate(appointmentDate);
                  //     const formattedToday = formatDate(today);

                  //     if (formattedAppointmentDate === formattedToday) {
                  //         UpdateRecordClick(e, ele, "forward");
                  //     } else {
                  //         swal({
                  //             // title: t("info"),
                  //             text: t("The follow up details can only be added when the Date of Follow up visit is same as today's date."),
                  //             icon: "info",
                  //             button: t("Close")
                  //         });
                  //     }
                  // }}
                  />
                ),
              };
              filterData.push(obj);
            });
            setDatatableList(filterData);
          } catch (e) {}
        }
        setGlobalSpinner(false);
      })
      .catch((error) => {
        setGlobalSpinner(false);
        swal({
          title: t("Error"),
          text: navigator.onLine
            ? t("Something went wrong, please try agian later.")
            : t("Data could not be shown in offline mode."),
          icon: "error",
          button: t("Close"),
        });
      });
  }

  const handleViewChange = (event, newValue) => {
    setViweType(newValue);
  };

  function UpdateRecordClick(e, PropsArray, pageType) {
    setGlobalSpinner(true);

    const formDataMassaged = {};
    const activeCaseDetails = {
      trackedEntityInstance: PropsArray.instanceuid,
      enrollmentId: "",
      type: "followUp",
      stageinstanceuid: pageType == "edit" ? "" : PropsArray.stageinstanceuid,
      stageuid: pageType == "edit" ? "" : PropsArray.stageuid,
    };
    const activeCaseFormData = {
      formFormat: null, //formDataMassaged,
      dhisFormat: null,
    };
    const linkContact = {
      enabled: false,
      linkTrackedEntityInstance: PropsArray.instanceuid,
    };
    OfflineDb.setDataIntoPouchDB("activeCaseDetails", activeCaseDetails);
    OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
    setGlobalSpinner(false);
    history.push("/layout/registration");
  }

  const updateInput = (input) => {
    setInput(input);
    let filteredList = [];
    setGlobalSpinner(true);
    if (input && input.length > 3) {
      Object.entries(searchAllResult).map(([key, val], idx) => {
        if (
          val[firstNameId] &&
          val[firstNameId].toLowerCase().indexOf(input.toLowerCase()) > -1
        ) {
          filteredList.push(val);
        }
      });
      setSearchResult({});
      setTimeout(function () {
        setGlobalSpinner(false);
        setSearchResult(filteredList);
      }, 500);
    } else {
      if (input.length == 0) {
        setSearchResult({});
        setTimeout(function () {
          setGlobalSpinner(false);
          setSearchResult(searchAllResult);
        }, 1000);
      } else {
        setGlobalSpinner(false);
      }
    }
  };

  const updatePatientName = (patientnameinput) => {
    setPatientNameInput(patientnameinput);
    let filteredList = [];
    setGlobalSpinner(true);
    if (patientnameinput && patientnameinput.length > 2) {
      Object.entries(searchAllResult).map(([key, val], idx) => {
        if (
          (val[firstNameId] &&
            val[firstNameId].toLowerCase().indexOf(patientnameinput.toLowerCase()) > -1) ||
          (val[uicId] &&
            val[uicId].toLowerCase().indexOf(patientnameinput.toLowerCase()) > -1) ||
          (val[contactnumberId] &&
            val[contactnumberId].toLowerCase().indexOf(patientnameinput.toLowerCase()) >
              -1)
        ) {
          filteredList.push(val);
        }
      });
      let filterData = [];
      filteredList.map((ele, i) => {
        let obj = {
          patientName: ele[firstNameId],
          famliyName: ele[famliyNameId],
          gender: ele[genderId],
          age: ele[ageId],
          contactNumber: ele[contactnumberId],
          uic: ele[uicId],
          regDate: ele[regdateId],
          edit: (
            <EditIcon
              className="edit-icon"
              onClick={(e) => UpdateRecordClick(e, ele, "edit")}
            //   onClick={(e) => {
            //     const appointmentDate = normalizeDate(ele["appointmentdate"])

            //     // Convert dates to YYYY-MM-DD format for comparison
            //     const formatDate = (date) => {
            //         const d = new Date(date);
            //         return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
            //     };

            //     const formattedAppointmentDate = formatDate(appointmentDate);
            //     const formattedToday = formatDate(today);

            //     if (formattedAppointmentDate === formattedToday) {
            //         UpdateRecordClick(e, ele, "edit");
            //     } else {
            //         swal({
            //             // title: t("info"),
            //             text: t("You can only edit the record on the day of appointment."),
            //             icon: "info",
            //             button: t("Close")
            //         });
            //     }
            // }}
            />
          ),
          followup: (
            <ArrowForwardIcon
              className="forward-icon"
              onClick={(e) => UpdateRecordClick(e, ele, "followup")}
            //   onClick={(e) => {
            //     const appointmentDate = normalizeDate(ele["appointmentdate"]);
            //     const formatDate = (date) => {
            //         const d = new Date(date);
            //         return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
            //     };

            //     const formattedAppointmentDate = formatDate(appointmentDate);
            //     const formattedToday = formatDate(today);

            //     if (formattedAppointmentDate === formattedToday) {
            //         UpdateRecordClick(e, ele, "forward");
            //     } else {
            //         swal({
            //             // title: t("info"),
            //             text: t("The follow up details can only be added when the Date of Follow up visit is same as today's date."),
            //             icon: "info",
            //             button: t("Close")
            //         });
            //     }
            // }}
            />
          ),
        };
        filterData.push(obj);
      });
      setDatatableList([]);
      setTimeout(function () {
        setGlobalSpinner(false);
        setDatatableList(filterData);
      }, 500);
    } else {
      if (patientnameinput.length == 0) {
        let filterData = [];
        Object.entries(searchAllResult).map(([key, ele], idx) => {
          let obj = {
            patientName: ele[firstNameId],
            famliyName: ele[famliyNameId],
            gender: ele[genderId],
            age: ele[ageId],
            contactNumber: ele[contactnumberId],
            uic: ele[uicId],
            regDate: ele[regdateId],
            edit: (
              <EditIcon
                className="edit-icon"
                onClick={(e) => {
                  const appointmentDate = normalizeDate(ele["appointmentdate"])

                  // Convert dates to YYYY-MM-DD format for comparison
                  const formatDate = (date) => {
                      const d = new Date(date);
                      return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
                  };

                  const formattedAppointmentDate = formatDate(appointmentDate);
                  const formattedToday = formatDate(today);

                  if (formattedAppointmentDate === formattedToday) {
                      UpdateRecordClick(e, ele, "edit");
                  } else {
                      swal({
                          // title: t("info"),
                          text: t("You can only edit the record on the day of appointment."),
                          icon: "info",
                          button: t("Close")
                      });
                  }
              }}
              />
            ),
            followup: (
              <ArrowForwardIcon
                className="forward-icon"
                onClick={(e) => {
                  const appointmentDate = normalizeDate(ele["appointmentdate"]);
                  const formatDate = (date) => {
                      const d = new Date(date);
                      return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
                  };

                  const formattedAppointmentDate = formatDate(appointmentDate);
                  const formattedToday = formatDate(today);

                  if (formattedAppointmentDate === formattedToday) {
                      UpdateRecordClick(e, ele, "forward");
                  } 
                  // else {
                  //     swal({
                  //         // title: t("info"),
                  //         text: t("The follow up details can only be added when the Date of Follow up visit is same as today's date."),
                  //         icon: "info",
                  //         button: t("Close")
                  //     });
                  // }
              }}
              />
            ),
          };
          filterData.push(obj);
        });
        setDatatableList([]);
        setTimeout(function () {
          setGlobalSpinner(false);
          setDatatableList(filterData);
        }, 500);
      } else {
        setGlobalSpinner(false);
      }
    }

    //if(filteredList.length > 0){
  };

  const loadViewToggleButtons = () => {
    return (
      <div className=" customregistrationtabs regcasetabs ">
        <AppBar position="static">
          <Tabs value={viewType} onChange={handleViewChange}>
            <Tab value="list" label={t("List View")}></Tab>
            <Tab value="card" label={t("Card View")}></Tab>
          </Tabs>
        </AppBar>
      </div>
    );
  };
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const renderFollowupCard = (props) => {
    const labelsArr = [];
    fieldsToDisplay.forEach((item) => {
      let obj = {};
      if (props.hasOwnProperty(item.trackedEntityAttribute.id)) {
        let fieldName = item.trackedEntityAttribute.description
          ? item.trackedEntityAttribute.description
          : item.trackedEntityAttribute.formName
          ? item.trackedEntityAttribute.formName
          : item.trackedEntityAttribute.displayName;
        obj[fieldName] = props[item.trackedEntityAttribute.id];
        labelsArr.push(obj);
      }
    });

    return viewType == "card" ? (
      <CardList
        AccordionLabel={
          labelsArr.find((x) => x["Patient Name"])
            ? labelsArr.find((x) => x["Patient Name"])["Patient Name"]
            : ""
        }
        AccordionContent={<></>}
        AccordionDataObject={labelsArr}
        TrackEntityId={props.instanceuid}
        Component={"TransferOut"}
        PropsArray={props}
      />
    ) : (
      <AccordianList
        AccordionLabel={
          labelsArr.find((x) => x["Patient Name"])
            ? labelsArr.find((x) => x["Patient Name"])["Patient Name"]
            : ""
        }
        AccordionContent={<> </>}
        AccordionDataObject={labelsArr}
        TrackEntityId={props.instanceuid}
        Component={"TransferOut"}
        PropsArray={props}
      />
    );
  };

  return (
    <section
      className="searchcustombg searchtabmaindiv myclientspage"
      style={{
        // backgroundColor: '#fff',
        flexGrow: 1,
        padding: 0,
      }}
    >
      <FooterMenu></FooterMenu>
      <div className="searchformcontainer followupsection">
        <p className="searchformheading">
          <span>
            <Trans>Follow up</Trans>
          </span>
        </p>
        <div className="patient-list follow-list">
          {window.cordova && (
            <SearchBar input={input} setKeyword={updateInput} />
          )}
          {window.cordova ? (
            searchResult.length > 0 && programData != null ? (
              <>
                {Object.entries(searchResult)
                  .slice(
                    (page - 1) * Configuration.pagination.itemsPerPage,
                    page * Configuration.pagination.itemsPerPage
                  )
                  .map(([key, val], idx) => {
                    var res = [];
                    res.push(val);
                    console.log(res, val, searchResult);
                    return res.map((item, index) => {
                      return renderFollowupCard(item, index);
                    });
                  })}

                <Pagination
                  count={noOfPages}
                  page={page}
                  onChange={handlePageChange}
                  defaultPage={1}
                  //color="primary"
                  size="large"
                  showFirstButton
                  showLastButton
                  variant="outlined"
                  shape="rounded"
                  className="pagination-form"
                />
              </>
            ) : (
              <span style={{ marginLeft: "24px" }}>{t("No Result Found")}</span>
            )
          ) : (
            searchResult.length > 0 &&
            programData != null && (
              <>
                <Grid container spacing={3} className="pagination-sec">
                  {/* <Grid item xs={2}>Search:</Grid> */}
                  <Grid item xs={12} className="p-0" >
                    <Tooltip
                      title={t("Search by Patient Name / UIC / Contact number")}
                      arrow
                    >
                      <SearchBar
                        input={patientnameinput}
                        setKeyword={updatePatientName}
                        placeholder={
                          "Search By: Patient Name / UIC / Contact number"
                        }
                      />
                    </Tooltip>
                  </Grid>
                  <CaseListInTableView
                    columns={columnHeader}
                    data={datatableList}
                  />
                </Grid>
              </>
            )
          )}
        </div>
      </div>
    </section>
  );
}
export default Followup;
